import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppProviders } from '@/app/providers'
import { router } from '@/app/router'

import '@/styles/global.css'

const root = document.getElementById('root')
const DYNAMIC_IMPORT_RELOAD_KEY = 'aihub:dynamic-import-reload-at'

function readDynamicImportError(value: unknown) {
  if (value instanceof Error) {
    return value.message
  }

  return typeof value === 'string' ? value : ''
}

function reloadAfterDynamicImportFailure() {
  const lastReloadedAt = Number(window.sessionStorage.getItem(DYNAMIC_IMPORT_RELOAD_KEY) ?? 0)
  const now = Date.now()

  if (now - lastReloadedAt < 10_000) {
    return
  }

  window.sessionStorage.setItem(DYNAMIC_IMPORT_RELOAD_KEY, String(now))
  window.location.reload()
}

window.addEventListener('vite:preloadError', ((event: Event) => {
  event.preventDefault()
  reloadAfterDynamicImportFailure()
}) as EventListener)

window.addEventListener('unhandledrejection', (event) => {
  const message = readDynamicImportError(event.reason)

  if (
    message.includes('Failed to fetch dynamically imported module') &&
    message.includes('/node_modules/.vite/deps/')
  ) {
    event.preventDefault()
    reloadAfterDynamicImportFailure()
  }
})

if (!root) {
  throw new Error('Root element #root was not found.')
}

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
